import bmwiVenturesPng from '../../../../../../client/assets_seller/about_us/logos/bmw-i-ventures.png';
import bmwiVenturesWebp from '../../../../../../client/assets_seller/about_us/logos/bmw-i-ventures.webp';
import iconiqPng from '../../../../../../client/assets_seller/about_us/logos/iconiq.png';
import iconiqWebp from '../../../../../../client/assets_seller/about_us/logos/iconiq.webp';
import indexVenturesPng from '../../../../../../client/assets_seller/about_us/logos/index-ventures.png';
import indexVenturesWebp from '../../../../../../client/assets_seller/about_us/logos/index-ventures.webp';
import localGlobePng from '../../../../../../client/assets_seller/about_us/logos/local-globe.png';
import localGlobeWebp from '../../../../../../client/assets_seller/about_us/logos/local-globe.webp';
import marchmontPng from '../../../../../../client/assets_seller/about_us/logos/marchmont.png';
import marchmontWebp from '../../../../../../client/assets_seller/about_us/logos/marchmont.webp';

const investorsList = [
  {
    imgPng: indexVenturesPng,
    imgWebp: indexVenturesWebp,
    link: 'https://www.indexventures.com',
    name: 'Index Ventures',
  },
  {
    imgPng: iconiqPng,
    imgWebp: iconiqWebp,
    link: 'https://iconiqcapital.com/',
    name: 'ICONIQ Capital',
  },
  {
    imgPng: marchmontPng,
    imgWebp: marchmontWebp,
    link: 'https://marchmontventures.com',
    name: 'Marchmont Ventures',
  },
  {
    imgPng: localGlobePng,
    imgWebp: localGlobeWebp,
    link: 'https://localglobe.vc',
    name: 'Local Globe',
  },
  {
    imgPng: bmwiVenturesPng,
    imgWebp: bmwiVenturesWebp,
    link: 'https://www.bmwiventures.com',
    name: 'BMW i Ventures',
  },
];

export default investorsList;
